import create from 'zustand';
import { persist } from 'zustand/middleware';

export const userFilterTableStore = (set) => ({
  name: '',
  createdEndDate: '',
  createdStartDate: '',
  status: [],
  role: [],
  sort: [ { field: 'name', dir: 'asc' } ],

  sortUserGridList: (e) => {
    set({ sort: e.sort });
  },
  resetUserGridFilter: () => {
    set({ name: '', createdEndDate: '', createdStartDate: '', status: [], role: [], sort: [ { field: 'name', dir: 'asc' } ] });
  },

  removeQuickFilter: (filterName) => {
    set({ [filterName]: '' });
  },
  removeRole: (roleName, id) => {
    set((state) => ({
      role: state.role?.filter((filteredRole) => filteredRole.aclRoleId !== id),
    }));
  },
  removeStatus: () => {
    set({ status: {}});
  },
  lastAppliedFilter: (prevFilters) => {
    set({ lastAppliedFilters: prevFilters });
  },
  onClickApplyFilter: (data) => {
    set({
      name: data?.name || '',
      createdEndDate: data?.createdEndDate || null,
      createdStartDate: data?.createdStartDate || null,
      sort: data?.sort || [ { field: 'name', dir: 'asc' } ],
      status: data?.status || [],
      role: data?.role || [],
    });
  },
  onClickApplyRoleFilterFromGrid: (roleData) => {
    set({ role: [ roleData ] });
  },
});
export const useuserFilterTableStore = create(
  persist(userFilterTableStore, {
    name: 'userListGrid',
  })
);
